// extracted by mini-css-extract-plugin
module.exports = {"listWrap":"running-record_listWrap_13NQe"};